(function() {
    'use strict';

    angular.module('app')
        .controller('addEditWineController', addEditWineController);

    function addEditWineController(wine, close, $http, loading) {
        var vm = this;
        vm.tracker = loading.createTracker();

        vm.wine = wine || {};

        vm.dismiss = close;

        vm.save = function () {
            vm.tracker.track(
                $http.post('/api/admin/wine', vm.wine)
                .then(close));
        }
    }   
}());